import script from "./FoodItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FoodItem.vue?vue&type=script&setup=true&lang=js"

import "./FoodItem.vue?vue&type=style&index=0&id=4c87ddd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c87ddd8"]])

export default __exports__